import Vue from "vue";
import Router from "vue-router";

import Login from "./views/Login.vue";

import jiaJiang from "./views/jiajiang/routes";
import qingShui from "./views/qingshui/routes";
import niZhou from "./views/nizhou/routes";
import daSha from "./views/dasha/routes";
import sutong from "./views/sutong/routes";
import nansi from "./views/nansi/routes";
import qipanzhou from "./views/qipanzhou/routes";
import hangzhouwan from "./views/hangzhouwan/routes";
import liede from "./views/liede/routes";
import aizhai from "./views/aizhai/routes";
import jinshajiang from "./views/jinshajiang/routes";
import guizhouInspectGroup from "./views/guizhouInspectGroup/routes";
import aipuruiInspectGroup from "./views/aipuruiInspectGroup/routes";
import jiashao from "./views/jiashao/routes";
import jiashaoCableTest from "./views/jiashaoCableTest/routes";
import jiangshun from "./views/jiangshun/routes";
import yichang from "./views/yichang/routes";
import yueqingwan from "./views/yueqingwan/routes";
import xihoumenSensor from "./views/xihoumenSensor/routes"
import xihoumenFreshAir from "./views/xihoumenFreshAir/routes"
import xihoumen from "./views/xihoumen/routes"
import balinghe from "./views/balinghe/routes"
import beipanjiang from "./views/beipanjiang/routes"
import averageAnalysis from "./views/averageAnalysis/routes"
import admin from "./views/admin/routes";
import selectBridge from "./views/selectBridge";
import { setTitle, verificationLoginPower } from "./routerMixin";
import routes from "./views/jiajiang/routes";

import cspTest from "./views/csptest.vue"

const error404 = () => import("./views/404.vue");

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "selectBridge",
      component: selectBridge,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/test/csp",
      name: "csp",
      component: cspTest,
    },
    ...jiaJiang,
    ...qingShui,
    ...admin,
    ...niZhou,
    ...daSha,
    ...sutong,
    ...nansi,
    ...qipanzhou,
    ...hangzhouwan,
    ...liede,
    ...aizhai,
    ...jinshajiang,
    ...guizhouInspectGroup,
    ...aipuruiInspectGroup,
    ...jiashao,
    ...jiashaoCableTest,
    ...yueqingwan,
    ...jiangshun,
    ...yichang,
    ...xihoumenSensor,
    ...xihoumenFreshAir,
    ...xihoumen,
    ...balinghe,
    ...beipanjiang,
    ...averageAnalysis,
    ...routes,
    {
      path: "*",
      component: error404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  setTitle(to);
  verificationLoginPower(to, from, router, next);
});

export default router;
